import React from "react";

import designIcon from "../../src/assests/images/Residential/Interior/Santhanam Residence @ Maduravoyal/Enscape_2023-09-13-22-25-08 (1).png";
import architectureIcon from "../../src/assests/images/hero-img.jpg";
import renovationIcon from "../../src/assests/images/Renovation/2.jpeg";
import landscapeIcon from "../../src/assests/images/KOTTURPURAM PARK REDEVELOPMENT/2_2 - Photo.jpg";

function FeaturedServices() {
  const services = [
    { icon: designIcon, title: "Interior Design", text: "Creative and functional interiors that reflect your style." },
    { icon: architectureIcon, title: "Architecture", text: "Innovative and sustainable architectural designs." },
    { icon: landscapeIcon, title: "Landscape Design", text: "Designing outdoor spaces that blend beauty and nature." },
    { icon: renovationIcon, title: "Renovation", text: "Transforming spaces while preserving their essence." },
  ];

  return (
    <section className="featured-services">
      <h2 className="section-title">Our Featured Services</h2>
      <p className="section-subtitle">Designs that redefine spaces with creativity and precision.</p>

      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.icon} alt={service.title} className="service-bg" />

            <div className="service-overlay">
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          </div>
          
        ))}
      </div>
    </section>
  );
}

export default FeaturedServices;
